/**
 * @module fetchAutodActionEndpoint
 */

import doesActionEndpointExistInCache from './doesActionEndpointExistInCache';
import doesActionEndpointExistInStore from './doesActionEndpointExistInStore';
import shouldRefreshActionEndpoint from './shouldRefreshActionEndpoint';
import refreshActionEndpoint from './refreshActionEndpoint';
import setActionEndpoint from '../mutators/setActionEndpoint';
import updateRequestState from '../mutators/updateActionEndpointRequestState';
import { ActionEndpointRequestState } from '../store/schema/actionEndpointCache';
import { getActionEndpointFromCache } from '../selectors/getActionEndpoint';

/**
 * @function
 * To check whether the action endpoint is present or not
 * @returns whether the action endpoint is present
 */
const fetchAutodActionEndpoint = () => {
    if (doesActionEndpointExistInStore()) {
        if (shouldRefreshActionEndpoint()) {
            refreshActionEndpoint();
        }
    } else if (doesActionEndpointExistInCache()) {
        setActionEndpoint(getActionEndpointFromCache());
        updateRequestState(ActionEndpointRequestState.Resolved);
        if (shouldRefreshActionEndpoint()) {
            refreshActionEndpoint();
        }
    } else {
        refreshActionEndpoint();
    }
};

export default fetchAutodActionEndpoint;
